export { CreacionTrasladoAlmacen } from "./pages/CreacionTrasladoAlmacen";


